import { FinancialsTableLayout } from '@/components/custom/companies/financials/financials-table'
import {
  useFinancialsTableState,
  type FinancialsTableOptions,
} from '@/hooks/use-financials-table-state'
import { usePortalFinancialsTable } from '@/hooks/use-portal-financials'

export function PortalFinancialsTable(options: FinancialsTableOptions) {
  const state = useFinancialsTableState(options)
  const query = usePortalFinancialsTable(state.queryParams)
  return (
    <FinancialsTableLayout
      state={state}
      query={query}
      idPrefix="portal-financial-statement"
    />
  )
}
